import SideNavbar from '../shared/SideNavbar';
import initApps from '../../lib/initApps';
import Mask from '../../lib/mask';
import HoverMenu from '../shared/hover_menu';
import SelectAllCheckboxes from '../shared/select_all_checkboxes';
import TraxCaseSelect2Enabler from './TraxCaseSelect2Enabler';
import TerminationModal from './termination_modal';
import ChatKit from '../shared/chatkit';

// Load Stimulus controllers
import 'controllers/index';

const allApps = [
  Mask,
  HoverMenu,
  SideNavbar,
  SelectAllCheckboxes,
  TerminationModal,
  TraxCaseSelect2Enabler,
  ChatKit
];

$(document).on('turbo:load', () => {
  initApps(allApps);
});
